// import React from "react";

// const studentReviews = [
//   {
//     icon: "💻",
//     name: "Karthik Raj",
//     course: "Full Stack Development",
//     review:
//       "The full stack course at CSG was amazing! I built real projects and learned both frontend and backend clearly.",
//   },
//   {
//     icon: "🖥️",
//     name: "Priya Dharshini",
//     course: "Linux Administration",
//     review:
//       "The trainers are very friendly and explained every concept practically. Now I can manage Linux servers confidently!",
//   },
//   {
//     icon: "🎨",
//     name: "Vignesh Kumar",
//     course: "3D Animation & VFX",
//     review:
//       "CSG’s animation lab is fantastic! I got hands-on experience using Maya and Blender — truly creative learning!",
//   },
//   {
//     icon: "⚙️",
//     name: "Divya Lakshmi",
//     course: "Hardware & Networking (A+ N+)",
//     review:
//       "Excellent place to learn networking basics and troubleshooting. The practical sessions helped me a lot.",
//   },
//   {
//     icon: "🌐",
//     name: "Arun Prakash",
//     course: "CCNA",
//     review:
//       "I cleared my CCNA certification with ease after the CSG training. The trainers are industry experts!",
//   },
//   {
//     icon: "🚀",
//     name: "Sowmiya S",
//     course: "Python Full Stack",
//     review:
//       "The course was well-structured and easy to follow. I’m now confident in developing full-fledged web apps.",
//   },
//   {
//     icon: "🧠",
//     name: "Hariharan M",
//     course: "Ethical Hacking",
//     review:
//       "Cybersecurity was taught in a fun, practical way! I learned real-world hacking and defense techniques safely.",
//   },
//   {
//     icon: "🎓",
//     name: "Meena Rajesh",
//     course: "UI/UX Designing",
//     review:
//       "Loved the creative sessions and design tools. My portfolio improved so much after this course!",
//   },
//   {
//     icon: "📈",
//     name: "Santhosh Kumar",
//     course: "Digital Marketing",
//     review:
//       "From SEO to social media ads, everything was taught in detail. Now I freelance successfully online.",
//   },
//   {
//     icon: "🔧",
//     name: "Keerthana V",
//     course: "Cloud Computing (AWS)",
//     review:
//       "The AWS training was very professional. Labs and case studies helped me understand cloud deeply.",
//   },
// ];

// export function StudentReviews() {
//   return (
//     <section
//       style={{
//         padding: "60px 20px",
//         background: "#fff",
//         color: "#333",
//         textAlign: "center",
//         overflow: "hidden",
//       }}
//     >
//       <h2
//         style={{
//           fontSize: "2.5rem",
//           fontWeight: "bold",
//           marginBottom: "30px",
//         }}
//         data-aos="fade-up"
//       >
//         Student Reviews
//       </h2>

//       {/* Scroll Container */}
//       <div
//         style={{
//           display: "flex",
//           gap: "20px",
//           animation: "scrollLeft 40s linear infinite",
//           width: "fit-content",
//         }}
//       >
//         {[...studentReviews, ...studentReviews].map((item, i) => {
//           const colors = ["#ff5722", "#673ab7", "#3f51b5", "#009688"];
//           return (
//             <div
//               key={i}
//               style={{
//                 position: "relative",
//                 background: "linear-gradient(145deg, #ffffff, #f4f4f4)",
//                 borderRadius: "20px",
//                 padding: "25px",
//                 boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
//                 border: "1px solid #eee",
//                 minWidth: "260px",
//                 flexShrink: 0,
//                 textAlign: "center",
//               }}
//             >
//               <div
//                 style={{
//                   position: "absolute",
//                   top: 0,
//                   right: 0,
//                   width: "35px",
//                   height: "35px",
//                   background: `linear-gradient(135deg, ${
//                     colors[i % colors.length]
//                   }, transparent)`,
//                   borderTopRightRadius: "20px",
//                   boxShadow: `0 0 10px ${colors[i % colors.length]}`,
//                 }}
//               ></div>

//               <div style={{ fontSize: "2rem", marginBottom: "10px" }}>
//                 {item.icon}
//               </div>
//               <h3
//                 style={{
//                   fontSize: "1.2rem",
//                   fontWeight: "bold",
//                   marginBottom: "5px",
//                 }}
//               >
//                 {item.name}
//               </h3>
//               <p style={{ fontSize: "0.9rem", color: "#777" }}>{item.course}</p>
//               <p
//                 style={{
//                   fontSize: "0.95rem",
//                   color: "#555",
//                   marginTop: "10px",
//                   lineHeight: "1.5",
//                 }}
//               >
//                 "{item.review}"
//               </p>
//             </div>
//           );
//         })}
//       </div>

//       {/* Keyframes */}
//       <style>
//         {`
//           @keyframes scrollLeft {
//             0% {
//               transform: translateX(0);
//             }
//             100% {
//               transform: translateX(-50%);
//             }
//           }

//           @media (max-width: 768px) {
//             @keyframes scrollLeft {
//               0% { transform: translateX(0); }
//               100% { transform: translateX(-80%); }
//             }
//           }
//         `}
//       </style>
//     </section>
//   );
// }

// import React, { useEffect, useRef, useState } from "react";

// const studentReviews = [
//   /* same array you provided */
//   {
//     icon: "💻",
//     name: "Karthik Raj",
//     course: "Full Stack Development",
//     review:
//       "The full stack course at CSG was amazing! I built real projects and learned both frontend and backend clearly.",
//   },
//   {
//     icon: "🖥️",
//     name: "Priya Dharshini",
//     course: "Linux Administration",
//     review:
//       "The trainers are very friendly and explained every concept practically. Now I can manage Linux servers confidently!",
//   },
//   {
//     icon: "🎨",
//     name: "Vignesh Kumar",
//     course: "3D Animation & VFX",
//     review:
//       "CSG’s animation lab is fantastic! I got hands-on experience using Maya and Blender — truly creative learning!",
//   },
//   {
//     icon: "⚙️",
//     name: "Divya Lakshmi",
//     course: "Hardware & Networking (A+ N+)",
//     review:
//       "Excellent place to learn networking basics and troubleshooting. The practical sessions helped me a lot.",
//   },
//   {
//     icon: "🌐",
//     name: "Arun Prakash",
//     course: "CCNA",
//     review:
//       "I cleared my CCNA certification with ease after the CSG training. The trainers are industry experts!",
//   },
//   {
//     icon: "🚀",
//     name: "Sowmiya S",
//     course: "Python Full Stack",
//     review:
//       "The course was well-structured and easy to follow. I’m now confident in developing full-fledged web apps.",
//   },
//   {
//     icon: "🧠",
//     name: "Hariharan M",
//     course: "Ethical Hacking",
//     review:
//       "Cybersecurity was taught in a fun, practical way! I learned real-world hacking and defense techniques safely.",
//   },
//   {
//     icon: "🎓",
//     name: "Meena Rajesh",
//     course: "UI/UX Designing",
//     review:
//       "Loved the creative sessions and design tools. My portfolio improved so much after this course!",
//   },
//   {
//     icon: "📈",
//     name: "Santhosh Kumar",
//     course: "Digital Marketing",
//     review:
//       "From SEO to social media ads, everything was taught in detail. Now I freelance successfully online.",
//   },
//   {
//     icon: "🔧",
//     name: "Keerthana V",
//     course: "Cloud Computing (AWS)",
//     review:
//       "The AWS training was very professional. Labs and case studies helped me understand cloud deeply.",
//   },
// ];

// export function StudentReviews() {
//   const scrollerRef = useRef(null);
//   const contentRef = useRef(null);
//   const [duration, setDuration] = useState(40); // default duration in seconds
//   const [isPaused, setIsPaused] = useState(false);

//   // measure widths and compute duration so animation speed remains consistent
//   useEffect(() => {
//     const el = contentRef.current;
//     const container = scrollerRef.current;
//     if (!el || !container) return;

//     // function to compute
//     function recompute() {
//       // total width of one set of cards
//       const contentWidth = el.scrollWidth / 2; // because we duplicate content
//       const containerWidth = container.clientWidth || 1;

//       // desired px/sec (control this to adjust speed)
//       const pixelsPerSecond = 150; // adjust: smaller = slower
//       const seconds = (contentWidth + containerWidth) / pixelsPerSecond;

//       // clamp duration
//       setDuration(Math.max(10, Math.min(120, Math.round(seconds))));
//     }

//     recompute();

//     // ResizeObserver to handle responsive changes
//     let ro;
//     if (window.ResizeObserver) {
//       ro = new ResizeObserver(recompute);
//       ro.observe(el);
//       ro.observe(container);
//     } else {
//       window.addEventListener("resize", recompute);
//     }

//     return () => {
//       if (ro) ro.disconnect();
//       else window.removeEventListener("resize", recompute);
//     };
//   }, []);

//   // Pause on hover (desktop) and on touch (mobile)
//   const handleMouseEnter = () => setIsPaused(true);
//   const handleMouseLeave = () => setIsPaused(false);
//   const handleTouchStart = () => setIsPaused(true);
//   const handleTouchEnd = () => setIsPaused(false);

//   const colors = ["#ff5722", "#673ab7", "#3f51b5", "#009688"];

//   return (
//     <section
//       style={{
//         padding: "48px 20px",
//         background: "#fff",
//         color: "#333",
//         overflow: "hidden",
//       }}
//     >
//       <h2
//         style={{
//           fontSize: "2rem",
//           fontWeight: "700",
//           marginBottom: "20px",
//           textAlign: "center",
//         }}
//         data-aos="fade-up"
//       >
//         Student Reviews
//       </h2>

//       {/* scroller viewport */}
//       <div
//         ref={scrollerRef}
//         onMouseEnter={handleMouseEnter}
//         onMouseLeave={handleMouseLeave}
//         onTouchStart={handleTouchStart}
//         onTouchEnd={handleTouchEnd}
//         style={{
//           width: "100%",
//           overflow: "hidden",
//           // keep things accessible:
//           WebkitOverflowScrolling: "touch",
//         }}
//       >
//         {/* content wrapper: contains two copies for seamless loop */}
//         <div
//           ref={contentRef}
//           style={{
//             display: "flex",
//             gap: 20,
//             alignItems: "stretch",
//             // create the animation using CSS variable for duration
//             animation: `scrollX ${duration}s linear infinite`,
//             animationPlayState: isPaused ? "paused" : "running",
//             // duplicate content width will determine smoothness
//           }}
//         >
//           {/* render two copies */}
//           {[0, 1].map((copyIndex) => (
//             <div
//               key={copyIndex}
//               style={{
//                 display: "flex",
//                 gap: 20,
//                 // each copy should not wrap; allow cards to shrink a bit on small screens
//                 flexWrap: "nowrap",
//               }}
//             >
//               {studentReviews.map((item, i) => (
//                 <article
//                   key={`${copyIndex}-${i}`}
//                   style={{
//                     position: "relative",
//                     background: "linear-gradient(145deg, #ffffff, #f8f8f8)",
//                     borderRadius: 16,
//                     padding: 20,
//                     boxShadow: "0 8px 20px rgba(0,0,0,0.06)",
//                     border: "1px solid #eee",
//                     // responsive sizing:
//                     minWidth: 220,
//                     maxWidth: 320,
//                     width: "clamp(220px, 25vw, 320px)",
//                     flexShrink: 0,
//                     textAlign: "left",
//                   }}
//                 >
//                   <div
//                     style={{
//                       position: "absolute",
//                       top: 0,
//                       right: 0,
//                       width: 36,
//                       height: 36,
//                       background: `linear-gradient(135deg, ${
//                         colors[i % colors.length]
//                       }, transparent)`,
//                       borderTopRightRadius: 16,
//                       boxShadow: `0 0 12px ${colors[i % colors.length]}`,
//                     }}
//                     aria-hidden
//                   ></div>

//                   <div style={{ fontSize: 26, marginBottom: 10 }}>
//                     {item.icon}
//                   </div>
//                   <h3
//                     style={{
//                       fontSize: 16,
//                       fontWeight: 700,
//                       marginBottom: 4,
//                     }}
//                   >
//                     {item.name}
//                   </h3>
//                   <p style={{ fontSize: 13, color: "#777", margin: 0 }}>
//                     {item.course}
//                   </p>
//                   <p
//                     style={{
//                       fontSize: 14,
//                       color: "#444",
//                       marginTop: 12,
//                       lineHeight: 1.4,
//                     }}
//                   >
//                     “{item.review}”
//                   </p>
//                 </article>
//               ))}
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* CSS Keyframes placed inline */}
//       <style>
//         {`
//           @keyframes scrollX {
//             0% { transform: translateX(0); }
//             100% { transform: translateX(-50%); } /* because content is duplicated */
//           }

//           /* small screens: slightly slower/longer view */
//           @media (max-width: 480px) {
//             /* optional: you can override animation speed via inline duration state */
//           }
//         `}
//       </style>
//     </section>
//   );
// }

import React, { useEffect, useRef, useState } from "react";

const studentReviews = [
  {
    icon: "💻",
    name: "Karthik Raj",
    course: "Full Stack Development",
    review:
      "The full stack course at CSG was amazing! I built real projects and learned both frontend and backend clearly.",
    rating: 5,
  },
  {
    icon: "🖥️",
    name: "Priya Dharshini",
    course: "Linux Administration",
    review:
      "The trainers are very friendly and explained every concept practically. Now I can manage Linux servers confidently!",
    rating: 4.5,
  },
  {
    icon: "🎨",
    name: "Vignesh Kumar",
    course: "3D Animation & VFX",
    review:
      "CSG’s animation lab is fantastic! I got hands-on experience using Maya and Blender — truly creative learning!",
    rating: 5,
  },
  {
    icon: "⚙️",
    name: "Divya Lakshmi",
    course: "Hardware & Networking (A+ N+)",
    review:
      "Excellent place to learn networking basics and troubleshooting. The practical sessions helped me a lot.",
    rating: 4,
  },
  {
    icon: "🌐",
    name: "Arun Prakash",
    course: "CCNA",
    review:
      "I cleared my CCNA certification with ease after the CSG training. The trainers are industry experts!",
    rating: 5,
  },
  {
    icon: "🚀",
    name: "Sowmiya S",
    course: "Python Full Stack",
    review:
      "The course was well-structured and easy to follow. I’m now confident in developing full-fledged web apps.",
    rating: 4.5,
  },
  {
    icon: "🧠",
    name: "Hariharan M",
    course: "Ethical Hacking",
    review:
      "Cybersecurity was taught in a fun, practical way! I learned real-world hacking and defense techniques safely.",
    rating: 5,
  },
  {
    icon: "🎓",
    name: "Meena Rajesh",
    course: "UI/UX Designing",
    review:
      "Loved the creative sessions and design tools. My portfolio improved so much after this course!",
    rating: 4.5,
  },
  {
    icon: "📈",
    name: "Santhosh Kumar",
    course: "Digital Marketing",
    review:
      "From SEO to social media ads, everything was taught in detail. Now I freelance successfully online.",
    rating: 4,
  },
  {
    icon: "🔧",
    name: "Keerthana V",
    course: "Cloud Computing (AWS)",
    review:
      "The AWS training was very professional. Labs and case studies helped me understand cloud deeply.",
    rating: 5,
  },
];

export function StudentReviews() {
  const scrollerRef = useRef(null);
  const contentRef = useRef(null);
  const [duration, setDuration] = useState(40);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    const el = contentRef.current;
    const container = scrollerRef.current;
    if (!el || !container) return;

    function recompute() {
      const contentWidth = el.scrollWidth / 2;
      const containerWidth = container.clientWidth || 1;

      const pixelsPerSecond = 150; // 🚀 increase this for faster scroll
      const seconds = (contentWidth + containerWidth) / pixelsPerSecond;

      setDuration(Math.max(10, Math.min(120, Math.round(seconds))));
    }

    recompute();

    let ro;
    if (window.ResizeObserver) {
      ro = new ResizeObserver(recompute);
      ro.observe(el);
      ro.observe(container);
    } else {
      window.addEventListener("resize", recompute);
    }

    return () => {
      if (ro) ro.disconnect();
      else window.removeEventListener("resize", recompute);
    };
  }, []);

  const handleMouseEnter = () => setIsPaused(true);
  const handleMouseLeave = () => setIsPaused(false);
  const handleTouchStart = () => setIsPaused(true);
  const handleTouchEnd = () => setIsPaused(false);

  const colors = ["#ff5722", "#673ab7", "#3f51b5", "#009688", "#e91e63"];

  // 🌟 Gradient star component
  const GradientStars = ({ rating, gradient }) => {
    const fullStars = Math.floor(rating);
    const halfStar = rating % 1 >= 0.5;

    return (
      <div
        style={{
          display: "flex",
          gap: "3px",
          marginTop: "8px",
          marginBottom: "8px",
        }}
      >
        {[...Array(5)].map((_, i) => (
          <span
            key={i}
            style={{
              fontSize: "18px",
              background: gradient,
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: i < fullStars ? "transparent" : "#ccc",
              opacity: i === fullStars && halfStar ? 0.7 : 1,
            }}
          >
            ★
          </span>
        ))}
      </div>
    );
  };

  return (
    <section
      style={{
        padding: "48px 20px",
        background: "#fff",
        color: "#333",
        overflow: "hidden",
      }}
    >
      <h2
        style={{
          fontSize: "2rem",
          fontWeight: "700",
          marginBottom: "20px",
          textAlign: "center",
        }}
      >
        Student Reviews
      </h2>

      <div
        ref={scrollerRef}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
        style={{
          width: "100%",
          overflow: "hidden",
          WebkitOverflowScrolling: "touch",
        }}
      >
        <div
          ref={contentRef}
          style={{
            display: "flex",
            gap: 20,
            alignItems: "stretch",
            animation: `scrollX ${duration}s linear infinite`,
            animationPlayState: isPaused ? "paused" : "running",
          }}
        >
          {[0, 1].map((copyIndex) => (
            <div
              key={copyIndex}
              style={{
                display: "flex",
                gap: 20,
                flexWrap: "nowrap",
              }}
            >
              {studentReviews.map((item, i) => {
                const color = colors[i % colors.length];
                const gradient = `linear-gradient(90deg, ${color}, ${
                  colors[(i + 1) % colors.length]
                })`;
                return (
                  <article
                    key={`${copyIndex}-${i}`}
                    style={{
                      position: "relative",
                      background: "linear-gradient(145deg, #ffffff, #f8f8f8)",
                      borderRadius: 16,
                      padding: 20,
                      boxShadow: "0 8px 20px rgba(0,0,0,0.06)",
                      border: "1px solid #eee",
                      minWidth: 220,
                      maxWidth: 320,
                      width: "clamp(220px, 25vw, 320px)",
                      flexShrink: 0,
                      textAlign: "left",
                    }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        right: 0,
                        width: 36,
                        height: 36,
                        background: `linear-gradient(135deg, ${color}, transparent)`,
                        borderTopRightRadius: 16,
                        boxShadow: `0 0 12px ${color}`,
                      }}
                    ></div>

                    <div style={{ fontSize: 26, marginBottom: 10 }}>
                      {item.icon}
                    </div>
                    <h3
                      style={{
                        fontSize: 16,
                        fontWeight: 700,
                        marginBottom: 4,
                      }}
                    >
                      {item.name}
                    </h3>
                    <p style={{ fontSize: 13, color: "#777", margin: 0 }}>
                      {item.course}
                    </p>

                    {/* ⭐ Rating with gradient */}
                    <GradientStars rating={item.rating} gradient={gradient} />

                    <p
                      style={{
                        fontSize: 14,
                        color: "#444",
                        marginTop: 8,
                        lineHeight: 1.4,
                      }}
                    >
                      “{item.review}”
                    </p>
                  </article>
                );
              })}
            </div>
          ))}
        </div>
      </div>

      <style>
        {`
          @keyframes scrollX {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
        `}
      </style>
    </section>
  );
}
